import axios from 'axios'
import { getCookie } from './cookies'
import * as Sentry from '@sentry/browser'
import qs from 'query-string'

export const API_HOST = import.meta.env.VITE_API_HOST as string
const API_PATH_V1 = (import.meta.env.VITE_API_PATH_V1 ||
  import.meta.env.VITE_API_PATH ||
  'api/v1') as string
const HOST_URL_V1 = `${API_HOST}${API_PATH_V1}`
const TOKEN_LOCALSTORAGE_KEY = import.meta.env
  .VITE_TOKEN_LOCALSTORAGE_KEY as string

export function getCsrfCookie() {
  return getCookie('csrftoken')
}

export function getToken() {
  return localStorage.getItem(TOKEN_LOCALSTORAGE_KEY)
}

export function setToken(token: string, reload = true) {
  localStorage.setItem(TOKEN_LOCALSTORAGE_KEY, token)
  if (reload) window.location.reload()
}

export function removeToken(reload = true) {
  localStorage.removeItem(TOKEN_LOCALSTORAGE_KEY)
  if (reload) window.location.reload()
}

const USER_TYPE_STORAGE_KEY = (import.meta.env
  .VITE_USER_TYPE_LOCALSTORAGE_KEY || 'FIRSTBITE@USER_TYPE') as string

export function getUserType() {
  return localStorage.getItem(USER_TYPE_STORAGE_KEY)
}

export function setUserType(userType: string) {
  localStorage.setItem(USER_TYPE_STORAGE_KEY, userType)
}

export function removeUserType() {
  localStorage.removeItem(USER_TYPE_STORAGE_KEY)
}

export function getClient({
  reloadOnAuthError = true,
  baseURL = HOST_URL_V1,
}: {
  reloadOnAuthError?: boolean
  baseURL?: string
} = {}) {
  const newInstance = axios.create()

  newInstance.defaults.baseURL = baseURL

  // Add default paramsSerializer to handle array parameters consistently
  newInstance.defaults.paramsSerializer = (params) => {
    return qs.stringify(params)
  }

  newInstance.interceptors.request.use((config) => {
    const csrftoken = getCsrfCookie()
    const token = getToken()
    const userTimezone = getCookie('fb_user_timezone')

    if (config.headers !== undefined) {
      if (token) {
        config.headers.set('Authorization', `token ${token}`)
      }
      if (csrftoken) {
        config.headers.set('X-CSRFToken', csrftoken)
      }
      config.headers.set('Referer-Path', window.location.pathname)
      config.headers.set('x-user-timezone', userTimezone)
    }

    return config
  })

  newInstance.interceptors.request.use(
    (config) => {
      config = {
        ...config,
        metadata: {
          startTime: new Date().getTime(),
        },
      } as any
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  newInstance.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response?.status === 400 || error.response?.status === 500) {
        const requestBody = error.config?.data
        const responseBody = error.response?.data
        Sentry.captureException(error, {
          extra: {
            requestBody,
            responseBody,
          },
        })
        return Promise.reject(error)
      }
      if (error.response?.status === 401 || error.response?.status === 403) {
        removeToken(reloadOnAuthError)
      }
      return Promise.reject(error)
    }
  )

  return newInstance
}

export const clientInstance = getClient({ baseURL: HOST_URL_V1 })
